import React from "react";
import { Link } from "react-router-dom";
import {
  MDBRow,
  MDBCol,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
} from "mdbreact";

import LinkReadToo from "../../../../template/LinkReadToo";
import ShareBtns from "../../../../template/ShareBtns";

import Banner from "../../../../template/Banner";

import bannerImg from "../../../../../assets/img/deficiencia-visual/banner1.jpg";

export default () => {
  const description = "Como conviver com o deficiente visual";

  return (
    <div className="como-conviver-deficiente-visual">
      <Banner title="DICAS" subtitle={description} img={bannerImg} />

      <MDBContainer className="mt-3">
        <MDBBreadcrumb>
          <MDBBreadcrumbItem>
            <Link to="/fundacao/deficiencia-visual" className="link-breadcrumb">
              Deficiência Visual
            </Link>
          </MDBBreadcrumbItem>
          <MDBBreadcrumbItem active>
            Dicas de como conviver com o deficiente visual
          </MDBBreadcrumbItem>
        </MDBBreadcrumb>
      </MDBContainer>

      <MDBContainer className="mt-4">
        <ShareBtns
          title={document.title}
          description={description}
          image={bannerImg}
        />
      </MDBContainer>

      <div className="content container d-flex justify-content-center align-items-center flex-column">
        <MDBRow>
          <MDBCol md="8" sm="12">
            <h1>As principais dicas são:</h1>
            <p>
              <li>
                Ao chegar em qualquer ambiente, cumprimente as pessoas
                presentes.{" "}
              </li>
              <li>Responda ao cumprimento de alguém. </li>
              <li>
                Não faça distinção no cumprimento abraçando uns e outros não.{" "}
              </li>
              <li>
                Ao se encontrar com pessoas com deficiência, mostre respeito,
                não tenha pena, nem dó, ele é um ser humano como você.
              </li>
              <li>
                Quando estiver na presença de pessoas com deficiência visual
                avise-o se precisar sair, para que ela não fique falando
                sozinha.{" "}
              </li>
              <li>
                Ao perceber uma pessoa vindo em sua direção facilite o acesso
                abrindo caminho.{" "}
              </li>
              <li>
                Se o celular tocar, avise a pessoa que você vai atender, para
                que ela saiba que você está falando com outra pessoa.{" "}
              </li>
              <li>
                Se perceber que uma pessoa corre perigo (buraco, degrau,
                orelhão, poste, lixeira suspensa.) avise-o.
              </li>
              <li>
                Quando precisar fazer reforma coloque obstáculos e fitas
                protegendo o desnivel.{" "}
              </li>
              <li>
                Não use termos como deste tamanho","desta altura Descreva mais
                detalhadamente possível, use medidas ou comparação com objetos
                que a pessoa conhece, por exemplo: um palmo, 30 cm, do tamanho
                de um garoto, tamanho de uma régua, três dedos.
              </li>
              <li>
                Avise a pessoa com deficiência visual se você for muda-la de
                direção, Não a vire de repente pois isto pode desequilibrá-la.{" "}
              </li>
              <li>
                Quando abordado sobre uma mensagem no celular, leja toda a
                mensagem em voz audivel. Evite dizer algo como: "é da vivo". O
                dono do celular deseja saber todo o teor da mensagem.{" "}
              </li>
              <li>
                Quando colocar a mesa avise a posição dos alimentos que tem à
                frente, à direita, à esquerda, para que a pessoa se sirva
                sozinha.{" "}
              </li>
              <li>
                Evite deixar comida no fogão O ideal é colocar as panelas ou
                vasilhas na mesa, facilitando o acesso da pessoa com deficiência
                visual.{" "}
              </li>
              <li>
                Ao arrumar a mesa coloque os talheres ao lado do prato e o copo
                acima do prato. Se pensarmos no prato como um relógio, os
                talheres devem estar na posição de 3 horas e o copo às 12 horas.
                Se a pessoa com deficiência visual for canhota os talheres
                deverão estar na posição de 4 horas.{" "}
              </li>
              <li>
                Na organização dos armários reserve lugares diferentes para os
                produtos de higiene, produtos de limpeza e temperos. Nunca
                coloque todos num mesmo espaço. Isso evita a ingestão de
                substâncias químicas.{" "}
              </li>
              <li>
                Não mude as coisas dos lugares habituais. Se precisar ou decidir
                mudar, comunique o novo lugar para a pessoa com deficiência
                visual.{" "}
              </li>
              <li>
                Sempre que sair da mesa empurre a cadeira para baixo da mesma,
                de modo que não atrapalhe a locomoção da pessoa com deficiência
                visual. Assim você evita acidentes.{" "}
              </li>
              <li>
                Após a refeição, separe os utensilios na pia: porções de
                Talheres pratos empilhados e copos separados facilitando o
                auxilio da pessoa com deficiência visual.
              </li>
              <li>
                Quando estiver em grupo, se estiver alguém falando não
                interrompo, espere a pessoa terminar.{" "}
              </li>
              <li>
                Não deixe bolsas, óculos ou celulares em sofás ou assentos.{" "}
              </li>
              <li>
                Reserve um lugar para vassouras e rodinhos e os mantenha ali.
                Não os deixe encostados em qualquer parede.{" "}
              </li>
              <li>
                Ao Usar tapete grande na sala tenha cuidado de prender as pontas
                para evitar que as bordas fiquem salientes alguém tropece. O
                tapete pode é uma cilada. Evite usá-lo.{" "}
              </li>
              <li>
                Sempre que abrir um armário, feche-o depois de usá-lo seja
                armário de roupa, cozinha ou banheiro{" "}
              </li>
              <li>
                Portas de acesso não devem ficar entreabertas. Deixe-as
                totalmente abertas ou totalmente fechadas.{" "}
              </li>
              <li>
                Você pode facilitar o acesso ao cafezinho deixando uma bandeja
                com xícara e garrafa térmica à disposição em cima da mesa ou
                balcão.{" "}
              </li>
              <li>
                Depois de usar um copo ou xícara, coloque-o dentro da pia. Nunca
                deixe na beirada da mesa ou pia.{" "}
              </li>
              <li>
                Estabeleça horários para que todos tenham direito de escolher o
                programa que querem assistir na TV.{" "}
              </li>
              <li>
                Evite conversar na sala quando a televisão estiver ligada, Fique
                atento pois a pessoa com deficiência visual segue a programação
                apenas com a audição
              </li>
              <li>
                Nunca abra uma correspondência endereçada a outro sem
                consentimento dele, é mais do que falta de educação, e crime{" "}
              </li>
              <li>
                Em qualquer passelo ou saída descreva o trajeto para auxiliar a
                fixação do mapa mental.{" "}
              </li>
            </p>
          </MDBCol>
          <MDBCol md="4" sm="12">
            <div style={{ position: "sticky", top: 100 }}>
              <h1>LEIA TAMBÉM</h1>
              <LinkReadToo
                path="/fundacao/deficiencia-visual"
                title="O que é deficiência visual?"
              />
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </div>
  );
};
